export default "__VITE_ASSET__D4aK4XKo__"